import usePDPGetStockAvailability from 'data-hooks/usePDPGetStockAvailability';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import useBackgroundProductBasicDetails from 'data-hooks/useProductBasicDetails/useBackgroundProductBasicDetails';
import useReadProductBasicDetails from 'data-hooks/useProductBasicDetails/useReadProductBasicDetails';
import usePDPGetBasicDetails from '../usePDPGetBasicDetails';
import usePDPCreateProductOptions from './usePDPCreateProductOptions';
import usePDPRedirectDoubleQuery from '../usePDPRedirectDoubleQuery';

const useMockHook = () => null;
const useBasicDetails = isNewConsumerApp ? useMockHook : usePDPGetBasicDetails;

const useBackgroundBasicDetails = isNewConsumerApp
  ? useBackgroundProductBasicDetails
  : useMockHook;

const useReadBasicDetails = isNewConsumerApp
  ? useReadProductBasicDetails
  : useMockHook;

const usePDPCreateContextValue = (
  {
    slug,
    isEditOrder = false,
    isQuickView = false,
    pdpIsModularBYOProduct = false,
    pdpVariantSkuOverride = null,
  } = {},
  { skip = false } = {}
) => {
  usePDPRedirectDoubleQuery();

  // In the old app, we load basic details directly here
  const basicDetailsExistingApp = useBasicDetails({ slug }, { skip });
  // In the new app, we start loading basic details in the background here, to
  // allow that data to be read later using the useReadProductBasicDetails hook
  const basicDetailsQueryRef = useBackgroundBasicDetails(null, slug, { skip });

  const { atoms, productOptions } = usePDPCreateProductOptions(
    {
      id: basicDetailsExistingApp?.data?.id,
      slug,
      basicDetailsQueryRef,
      pdpVariantSkuOverride,
      shouldUpdateQueryParam: !isQuickView && !isEditOrder,
    },
    { skip }
  );

  const basicDetailsNewApp = useReadBasicDetails(basicDetailsQueryRef);

  const basicDetails = isNewConsumerApp
    ? basicDetailsNewApp
    : basicDetailsExistingApp;

  // Get stock status for product
  const stockAvailability = usePDPGetStockAvailability({
    basicDetails,
    productOptions,
  });

  return {
    atoms,
    basicDetails,
    id: basicDetails?.data?.id || null,
    pdpIsModularBYOProduct,
    pdpVariantSkuOverride,
    pdpIsAvailableInSizesOpen: true,
    productOptions,
    stockAvailability,
    slug,
  };
};

export default usePDPCreateContextValue;
